var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { serializeResponse } from '../utils';
var cacheName = 'useHTTPcache';
var getCache = function getCache() {
  try {
    return JSON.parse(localStorage.getItem(cacheName) || '{}');
  } catch (err) {
    localStorage.removeItem(cacheName);
    return {};
  }
};
var getLocalStorage = function getLocalStorage(_a) {
  var cacheLife = _a.cacheLife;
  var remove = function remove() {
    var responseIDs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      responseIDs[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
      var cache;
      return __generator(this, function (_a) {
        cache = getCache();
        responseIDs.forEach(function (id) {
          return delete cache[id];
        });
        localStorage.setItem(cacheName, JSON.stringify(cache));
        return [2 /*return*/];
      });
    });
  };

  var isExpired = function isExpired(responseID) {
    var cache = getCache();
    var _a = cache[responseID] || {},
      expiration = _a.expiration,
      response = _a.response;
    var expired = expiration > 0 && expiration < Date.now();
    if (expired) remove(responseID);
    return expired || !response;
  };
  var has = function has(responseID) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2 /*return*/, !isExpired(responseID)];
      });
    });
  };
  var get = function get(responseID) {
    return __awaiter(void 0, void 0, void 0, function () {
      var cache, _a, body, headers, status, statusText;
      return __generator(this, function (_b) {
        if (isExpired(responseID)) return [2 /*return*/];
        cache = getCache();
        _a = cache[responseID].response, body = _a.body, headers = _a.headers, status = _a.status, statusText = _a.statusText;
        return [2 /*return*/, new Response(body, {
          status: status,
          statusText: statusText,
          headers: new Headers(headers || {})
        })];
      });
    });
  };
  var set = function set(responseID, response) {
    return __awaiter(void 0, void 0, void 0, function () {
      var cache, _a, _b, _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            cache = getCache();
            _a = cache;
            _b = responseID;
            _c = {};
            return [4 /*yield*/, serializeResponse(response)];
          case 1:
            _a[_b] = (_c.response = _d.sent(), _c.expiration = Date.now() + cacheLife, _c);
            localStorage.setItem(cacheName, JSON.stringify(cache));
            return [2 /*return*/];
        }
      });
    });
  };

  var clear = function clear() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        localStorage.setItem(cacheName, JSON.stringify({}));
        return [2 /*return*/];
      });
    });
  };

  return Object.defineProperties(getCache(), {
    get: {
      value: get,
      writable: false
    },
    set: {
      value: set,
      writable: false
    },
    has: {
      value: has,
      writable: false
    },
    delete: {
      value: remove,
      writable: false
    },
    clear: {
      value: clear,
      writable: false
    }
  });
};
export default getLocalStorage;